<template>
  <div>
    <HMTSlideshow>
      <PlayButton />
    </HMTSlideshow>
  </div>
</template>

<script>
  import HMTSlideshow from '@/shared/components/Slideshow';
  import PlayButton from '../../components/PlayButton';

  export default {
    name: 'Slideshow',
    components: {
      HMTSlideshow,
      PlayButton
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .slideshow {

    .hmt-slideshow {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: transparent;
        background-image: linear-gradient(180deg, transparent 0%, transparent 85%, #000000 100%);
      }
    }

    .hmt-slideshow__item {
      box-shadow: inset 0 -10px 10px -10px #000;
      background-color: #000 !important;
    }

    .hmt-slideshow__controls {
      left: auto;
      right: 70px;
      height: 45px;
    }

    .hmt-slideshow__controls-play {
      background-color: transparent;

      &:hover {
        svg {
          color: #fff;
        }
      }
    }

    .hmt-slideshow__controls-play-button {
      border: none;

      &:hover {
        svg {
          color: #fff;
        }
      }

      svg {
        width: 14px !important;
      }
    }

    .hmt-slideshow__controls-nav {
      margin-left: 0;
      background-color: transparent;
      color: #fff;
    }

    .hmt-slideshow__controls-nav-button {
      svg {
        color: #fff;
      }

      &:hover {
        svg {
          color: #fff;
        }
      }
    }

    .hmt-slideshow__fullscreen {
      height: 45px;
      background-color: transparent;

      &:hover {
        svg {
          color: #fff;
        }
      }
    }
  }
</style>
